import { useState } from "react";
import styles from "./styles/Contact.module.css"; 

export default function Contact() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Button */}
      <div className={styles.contactFloating} onClick={() => setIsOpen(true)}>
        <span className={styles.icon}>✉</span>
        <span className={styles.label}>Kontakt</span>
      </div>

      {/* Modal-Fenster */}
      {isOpen && (
        <div className={styles.modalOverlay} onClick={() => setIsOpen(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h2>Kontakt aufnehmen</h2>
            <p>Schreib mir gerne direkt per E-Mail.</p>
            <a className={styles.cta} href="mailto:gessenharter@yahoo.com">
              E-Mail senden
            </a>
            <p className={styles.subline}></p>
            <button className={styles.closeButton} onClick={() => setIsOpen(false)}>
              Schließen
            </button>
          </div>
        </div>
      )}
    </>
  );
}
